import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Header = ({ title, isIcon }) => {
  const navigate = useNavigate();

  return (
    <Container className='container-fluid py-3'>
      <HeaderWrapper>
        <HeaderBackButtonWrapper>
          <Icon className='i-nav-back' onClick={() => navigate(-1)} />
        </HeaderBackButtonWrapper>
        <HeaderTitleWrapper className='d-flex row pt-3'>
          <HeaderText className='px-3 font-weight-bolder'>{title}</HeaderText>
          {isIcon && (
            <HeaderIconContainer className='d-flex flex-row align-items-center px-3'>
              <a href='aptstoryapp://configure'>
                <Icon className='i-nav-setting' />
              </a>
            </HeaderIconContainer>
          )}
        </HeaderTitleWrapper>
      </HeaderWrapper>
    </Container>
  );
};

const Container = styled.section``;
const HeaderWrapper = styled.section``;
const HeaderBackButtonWrapper = styled.article`
  width: 50px;
`;
const HeaderTitleWrapper = styled.article`
  justify-content: space-between;
`;

const HeaderText = styled.h1``;
const HeaderIconContainer = styled.article``;
const Icon = styled.i``;

export default Header;
